<template>
  <!--! To here -->
  <div v-if="site" class="site-info">

    <AcceptSection :title="SectionTitles.SITE_SAFETY" :read-only="true" :items="siteSafety" type="safety" class="site-safety-information">
      <template v-slot:item="{ item }">
        <div v-for="(subitem, index) in item.list" v-bind:key="'div-item-' + SectionTitles.SITE_SAFETY + '-' + index">
          <span class="section-content-title" v-html="subitem.title"></span><br/>
          <span v-if="subitem.detail" class="section-content-list" v-html="subitem.detail"></span><br v-if="subitem.detail" />
          <div v-for="listing in subitem.phoneList" class="section-phone-listing" :key="listing.phone">
            <span>{{ listing.name }}</span>
            <a :href="`tel:${listing.phone}`">{{ listing.phone }}</a>
          </div>
          <br/>
        </div>
        <!--
          <span class="section-content-title" v-html="item.title"></span><br/>
          <span v-if="item.detail" class="section-content-list" v-html="item.detail"></span>
          <div v-for="listing in item.phoneList" class="section-phone-listing" :key="listing.phone">
            <span>{{ listing.name }}</span>
            <a :href="`tel:${listing.phone}`">{{ listing.phone }}</a>
          </div>
        -->
      </template>
      <template #extra v-if="site.medicalCentreLatLng">
        <p class="text-center">See below for directions to medical centre</p>
        <GmapMap
          :center="latLngToObject(site.medicalCentreLatLng)"
          :zoom="15"
          map-type-id="roadmap"
          style="width: 100%; height: 300px;"
        >
          <GmapMarker
            :position="latLngToObject(site.medicalCentreLatLng)"
            :clickable="true"
            :draggable="false"
            :title="site.name"
          />
        </GmapMap>
      </template>
    </AcceptSection>

    <!--! Moved from here -->
    <b-row class="wizard-step site-details">
      <b-col>
        <div class="row section-title">
          <h3>{{ SectionTitles.SITE_DETAILS }}</h3>
        </div>
        <BasicSiteDetails :site="site"/>
      </b-col>
    </b-row>

    <AcceptSection v-if="site.allCriticalRisks && site.allCriticalRisks.length > 0" :title="SectionTitles.CRITICAL_HAZARDS" :read-only="true" :items="site.allCriticalRisks" type="allCriticalRisks">
      <template v-slot:item="{ item }">
        <span class="section-content-title-and-desc" v-html="item.risk"></span>
      </template>
    </AcceptSection>

    <AcceptSection v-if="site.standardRisks && site.standardRisks.length > 0" :title="SectionTitles.GENERAL_HAZARDS" :read-only="true" :items="site.standardRisks" type="standardRisks">
      <template v-slot:item="{ item }">
        <span class="section-content-title-and-desc" v-html="item.risk"></span>
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.WORKSAFE_TASKS" :read-only="true" :items="site.tasks" type="tasks">
      <template #instructions>
        All WorkSafe notifiable tasks are notified to WorkSafe at least 24 hours before the work is undertaken.
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.PPE_REQUIREMENTS" :read-only="true" :items="site.ppe" type="ppe" btnClasses="" class="section-ppe">
      <template #instructions>
        The following PPE is required on this site. Refer to the JSEAs fo other task-specific PPE requirements.
      </template>
      <template v-slot:item="{ item }">
        <ppe-icon :ppe="item.title"/>
      </template>
    </AcceptSection>

    <b-row class="section-title" v-if="showQRCode">
      <h3>Sign-In Poster</h3>
    </b-row>
    <b-row v-if="showQRCode">
      <b-col class="pt-2 pb-2">
        <SitePoster :boundSite="site"/>
      </b-col>
    </b-row>

    <b-row class="section-title" v-if="signIns.length > 0">
      <h3>Todays Sign-In Register</h3>
    </b-row>

    <b-row class="section-content-container">
      <b-col v-for="(signIn, index) in signIns" v-bind:key="index" class="section-content sign-in-register-content flex-column">
          <p class="name">{{signIn.name}}</p>
          <p>{{signIn.company}}</p>
          <p class="small">Signed in: {{signIn.signInTime | moment('timezone', 'Pacific/Auckland', 'h:mm A')}}</p>
          <p class="small">Signed out: <span v-if="signIn.signOutTime" >{{signIn.signOutTime | moment('timezone', 'Pacific/Auckland', 'h:mm A')}}</span></p>
          <p class="small">
            COVID-19 Responses:
            {{Object.values(signIn.responses.covid19).join(', ')}}
          </p>
      </b-col>
    </b-row>
  </div>
  <b-container v-else/>
</template>

<script>
import { getSignIns } from '@/lib/api';
import { EventBus } from '@/lib/event-bus';
import SitePoster from '@/components/SitePoster.vue';
import BasicSiteDetails from '@/components/siteParts/BasicSiteDetails.vue';
import AcceptSection from '@/components/siteParts/AcceptSection.vue';
import PpeIcon from '@/components/siteParts/icons/PpeIcon.vue';
import emailAddressTranslation from '@/lib/email-address-translation';
import {
  formatSite,
  SectionTitles, // eslint-disable-line no-unused-vars
} from '@/lib/generic-lists';

export default {
  name: 'Site',
  components: {
    SitePoster,
    BasicSiteDetails,
    AcceptSection,
    PpeIcon,
  },
  props: {
    boundSite: {
      type: Object,
      default: () => null,
    },
    loadSignIns: {
      type: Boolean,
      default: () => false,
    },
    showQRCode: {
      type: Boolean,
      default: () => false,
    },
    editing: Boolean,
  },
  watch: {
    boundSite() {
      try {
        this.updateSite();
        this.$refs.jobNumber.focus();
      } catch (error) {
        if (error instanceof TypeError) {
          console.log('This is to be expected');
        } else {
          console.log(error);
        }
      }
    },
    editing: {
      handler() {
        this.$refs.jobNumber.focus();
      },
      deep: true,
    },
  },
  data() {
    return {
      rawSite: {},
      signIns: [],
      SectionTitles,
    };
  },
  mounted() {
    this.updateSite();
    if (this.$refs.jobNumber) {
      this.$refs.jobNumber.scrollIntoView();
    }
  },
  computed: {
    site() {
      if (!this.rawSite) return {};
      return formatSite(this.rawSite);
    },
    siteSafety() {
      return [{ list: this.site.safety }];
    },
  },
  methods: {
    async updateSite() {
      if (!this.boundSite) return;
      EventBus.$emit('showLoader');
      this.rawSite = this.boundSite;
      if (this.loadSignIns) {
        this.signIns = await getSignIns(this.rawSite.id);
      } else {
        this.signIns = [];
      }
      this.rawSite.foreperson = emailAddressTranslation(this.rawSite.forepersonUsername);
      this.rawSite.contractManager = emailAddressTranslation(this.rawSite.ownerUsername);
      EventBus.$emit('hideLoader');
    },
    latLngToObject(latLng) {
      if (!latLng || latLng.trim().length === 0) return null;
      const parts = latLng.split(/,{1}\s{0,1}/g);
      return {
        lat: parseFloat(parts[0]),
        lng: parseFloat(parts[1]),
      };
    },
  },
};
</script>

<style>
</style>
